export default __webpack_public_path__ + "static/media/N_Neve.d5ee425f.mp3";